import React from 'react';
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";


const CircularProgressBar = ({percentage, color="#475467" , circleRatio=0.5 , text , styles}) => {
  return (
    <div>
       <CircularProgressbar
            value={percentage}
            text={`${text || percentage}`}
            circleRatio={circleRatio}
            styles={buildStyles({
              rotation: 0.75,
              strokeLinecap: "round",
              pathColor: color,
              trailColor: "#eee"
            })}
          />
    </div>
  )
}

export default CircularProgressBar;
